<template>
  <span>
    <div class="tour-360" 
      :class="{
        'tour-360--autoplay': cmp.name === 'Matterport' && isAutoplay(cmp.url) && isMobile() && !isTop
      }"
      v-for="cmp in componentList" 
      :key="cmp.url"
    >
      <component :is="cmp.name" :url="cmp.url"></component>
    </div>
  </span>
</template>

<script>
  import { mapState } from 'vuex'
  import Matterport from './matterport/matterport.vue'
  import IGuide from './iguide/iguide.vue'
  import CloudPano from './cloudPano/cloudPano.vue'
  import Zillow from './zillow/zillow.vue'
  import deviceMixin from '@/shared/mixins/device'

  export default {
    mixins: [deviceMixin],
    components: {
      Matterport,
      IGuide,
      CloudPano,
      Zillow
    },
    props: {
      isTop: {
        default: false,
        type: Boolean
      }
    },
    computed: {
      ...mapState('tours', ['tour360']),
      componentList () {
        const data = this.tour360

        if (!data) {
          return []
        }

        if (data.tours) {
          const result = data.tours.map(item => {
            const name = (item.name === 'matterport' && 'Matterport') 
              || (item.name === 'iguide' && 'IGuide') 
              || (item.name === 'cloudPano' && 'CloudPano')
              || (item.name === 'zillow' && 'Zillow');

            return {
              name,
              url: item[item.name]
            }
          })

          return this.isTop && result.length > 0 ? [result[0]] : result;
        } else if (data.matterport || data.iguide || data.cloudPano) {
          const name = (data.matterport && 'Matterport') || (data.iguide && 'IGuide') || (data.cloudPano && 'CloudPano');

          return [{
            name,
            url: (data.matterport && data.matterportUrl) || (data.iguide && data.iguideUrl) || (data.cloudPano && data.cloudPanoUrl)
          }]
        } else {
          return []
        }
      },
      isAutoplay () {
        return url => url ? url.includes('play=1') : false;
      }
    },
  }
</script>

<style lang="scss">
  .tour-360 {
    position: relative;
    margin-bottom: 40px;
    padding-top: 56.25%;

    &--autoplay {
      height: 70vh;
    }

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: none;
    }
  }
</style>
